import { type FC } from 'react'
import { FaCalendar } from 'react-icons/fa'

import { Button } from '@/components/elements'
import { ACTIONS } from '@/constants/common/message.constants'

import { RegularScheduleCalendar } from '../RegularScheduleCalendar'

interface CalendarPanelProps {
  show: boolean
  /** カレンダーの基準日。未確定なら描画しない */
  baseDate: Date | null
  selectedDates: Date[]
  existingDates: Date[]
  editingDate: Date
  tourDates: Date[]
  onDateSelect: (date: Date) => void
  onDateDeselect: (date: Date) => void
}

/**
 * 定期運行カレンダーのパネル。モーダルフッタ内で、履歴チェックボックス行より上に置く。
 * 展開してもボタン・保存の位置が動かないよう、開閉するのはこのパネルだけに閉じる。
 */
export const RegularScheduleCalendarPanel: FC<CalendarPanelProps> = ({
  show,
  baseDate,
  selectedDates,
  existingDates,
  editingDate,
  tourDates,
  onDateSelect,
  onDateDeselect
}) => {
  if (!show || !baseDate) return null

  return (
    // 上下パディングは RegularScheduleCalendar 側の py-4 が担うため、ここは左右のみ
    <div className="w-full rounded border bg-gray-50 px-4">
      <RegularScheduleCalendar
        baseDate={baseDate}
        selectedDates={selectedDates}
        existingDates={existingDates}
        editingDate={editingDate}
        onDateSelect={onDateSelect}
        onDateDeselect={onDateDeselect}
        tourDates={tourDates}
      />
    </div>
  )
}

interface ToggleButtonProps {
  showCalendar: boolean
  disabled: boolean
  /** 閉じている時のラベル。配車済み/未配車・新規/既存で呼び出し側が出し分ける */
  openLabel: string
  onToggle: () => void
}

/** 定期運行カレンダーの開閉ボタン */
export const RegularScheduleToggleButton: FC<ToggleButtonProps> = ({
  showCalendar,
  disabled,
  openLabel,
  onToggle
}) => (
  <Button
    type="default"
    icon={<FaCalendar />}
    onClick={onToggle}
    disabled={disabled}
  >
    {showCalendar ? ACTIONS.CLOSE_REGULAR_OPERATION_EDIT : openLabel}
  </Button>
)
